export const nameAndSurnameValidation = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (value.length < 1 || value.length > 20) {
      return "Имя не может быть больше 20 символов";
    }
    return true;
  },
};





export const emailValidation = {
  required: "Обязательно для заполнения", validate: (value: string) =>
  {const regularEmail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    if (!regularEmail.test(value)) { return "Введите корректный e-mail"; } return true; }, };






export const emailValidationRegistration = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    const regularEmail =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    const allowedDomains = ["yandex.ru", "ya.ru", "mail.ru", "bk.ru", "inbox.ru", "list.ru", "internet.ru", "rambler.ru", "gmail.com"];
    const email = value.trim().toLowerCase();

    if (!regularEmail.test(email)) {
      return "Введите корректный e-mail";
    }

    const domain = email.split("@")[1];

    if (!allowedDomains.includes(domain)) {
      return "Регистрация возможна только с почтами РФ";
    }

    return true;
  },
};


export const phoneValidation = {
  required: "Обязательно для заполнения",
  maxLength: 17,
};

const regularPass =
  /([a-z]+[A-Z]+[0-9]+|[a-z]+[0-9]+[A-Z]+|[A-Z]+[a-z]+[0-9]+|[A-Z]+[0-9]+[a-z]+|[0-9]+[a-z]+[A-Z]+|[0-9]+[A-Z]+[a-z]+)/;
export const passValidation = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (!regularPass.test(value) || value.length < 8) {
      return "Пароль должен состоять из 8 или более символов и включать в себя цифры, латинские буквы верхнего и нижнего регистра";
    }
    return true;
  },
};

export const passValidationUser = {
  required: false,
  validate: (value: string) => {
    if (value.length > 0) {
      if (!regularPass.test(value) || value.length < 8) {
        return "Пароль должен состоять из 8 или более символов и включать в себя цифры, латинские буквы верхнего и нижнего регистра";
      }
    }
    return true;
  },
};

export const subjectValidations = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (value.length > 40) {
      return "Тема сообщения должна быть не более 40 символов";
    }
    return true;
  },
};

export const messageValidation = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (value.length > 400) {
      return "Сообщение не должно быть более 300 символов";
    }
    return true;
  },
};


export const descValidation = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (value.length > 300) {
      return "Описание не должно быть более 300 символов";
    }
    return true;
  },
};

export const nikValidation = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (value.length > 30) {
      return "Ник не должен быть более 30 символов";
    }
    return true;
  },
};


export const telegaValidation = {
  required: "Обязательно для заполнения",
  validate: (value: string) => {
    if (value.length > 50) {
      return "Ссылка на Telegram не должна быть более 50 символов";
    }
    return true;
  },
};




export const imgValidation = {
  validate: (value: string) => {
    if (value[0]) {
      return "Ссылка на Telegram не должна быть более 50 символов";
    }
    return true;
  },
};